













































import { Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { GamificationBadge } from '@/api/model/gamification-badge'
import { BadgeType } from '@/api/types'

@Component
export default class Scores extends Vue {

    mounted() {
        this.calculateScrollbarWidthVar()
    }

    numberOfBadgesForRank(user: User, rank: number): number {
        return this.getUserBadges(user).filter(badge => {
            return badge.rank === rank
        }).length
    }

    pointsForUser(user: User): number {
        let points = 0

        this.getUserBadges(user).forEach(badge => {
            points += badge.points
        })

        return points
    }

    getUserBadges(user: User): GamificationBadge[] {
        return user.gamificationBadges.filter(badge => {
            return this.isEnabled(badge.type)
        })
    }

    get users(): User[] {
        let users = this.$currentCompany.users.filter(user => this.getUserBadges(user).length > 0)
        if (users.length === 0) {
            users = this.$currentCompany.getAvailableUsers()
        }

        return users.sort((a, b) => {
            const totals = { points: 0, rank1: 0, rank2: 0, rank3: 0 }
            const totalsA = { ...totals }
            const totalsB = { ...totals }

            this.getUserBadges(a).forEach(badge => {
                totalsA.points += badge.points
                totalsA[`rank${badge.rank}`]++
            })

            this.getUserBadges(b).forEach(badge => {
                totalsB.points += badge.points
                totalsB[`rank${badge.rank}`]++
            })

            for (const key of Object.keys(totals)) {
                if (totalsB[key] !== totalsA[key]) {
                    return totalsB[key] - totalsA[key]
                }
            }

            return a.name.localeCompare(b.name)
        })
    }

    isEnabled(badgeType: BadgeType): boolean {
        return this.$currentCompany.gamificationSettings.activatedBadges.includes(badgeType)
    }

    get componentClass() {
        return {
            scores: true,
        }
    }

    calculateScrollbarWidthVar() {
        const scrollbox = document.createElement('div')
        scrollbox.style.overflow = 'scroll'

        document.body.appendChild(scrollbox)
        const scrollbarWidth = scrollbox.offsetWidth - scrollbox.clientWidth
        document.body.removeChild(scrollbox)

        document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
    }
}

